import React from "react";

const collapsedIcon = (
  <svg
    fill="#e37023"
    height="24"
    style={{ pointerEvents: "none" }}
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
    <path d="M0-.25h24v24H0z" fill="none" />
  </svg>
);

const collapsedIconEmpty = (
  <svg
    fill="currentColor"
    style={{ pointerEvents: "none" }}
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
    <path d="M0-.25h24v24H0z" fill="none" />
  </svg>
);

const expandedIcon = (
  <svg
    fill="#e37023"
    style={{ pointerEvents: "none" }}
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
    <path d="M0-.75h24v24H0z" fill="none" />
  </svg>
);

const expandedIconEmpty = (
  <svg
    fill="currentColor"
    style={{ pointerEvents: "none" }}
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
    <path d="M0-.75h24v24H0z" fill="none" />
  </svg>
);

const CustomExpanderIcon = ({ row, emptyWhen }) => {
  if (emptyWhen(row)) {
    return row.expanded ? expandedIconEmpty : collapsedIconEmpty;
  }

  return row.expanded ? expandedIcon : collapsedIcon;
};

export default CustomExpanderIcon;
